<template>
  <div>
    <QuotationHeader :img_header="header_image" header="ใบเสนอราคา" link_back="stock/quotation/quotationwebsite"/>
    <Quotation_detail_shop/>
  </div>
</template>

<script>
import QuotationHeader from "@/components/admin/stock/quotation/header_quotation/QuotationHeader";
import HeaderImage from "@/assets/quotation.png";
import Quotation_detail_shop from "@/components/admin/stock/quotation/Quotation_detail_shop";
export default {
  name: "QuotationDetailShop",
  components: {
    Quotation_detail_shop,
    QuotationHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
